module.exports = __webpack_public_path__ + "img/7.df20be76.jpg";